import { AcessoPermissaoNaAgendaComLogType } from '@/types/agendas/AcessoPermissaoNaAgendaComLogType';
import http from './ApiConfig';
import { Service } from './Service';

export class AgendaService extends Service {
  constructor() {
    super('agenda');
  }

  public ObterTodosOsHorariosReservadosDesdeHoje() {
    return http.get(`${this._nomeControle}/obter-horarios-reservados`, this.GetHeader());
  }

  public RemoverUsuarioDaAgenda(agendaId: number, usuarioId: string) {
    return http.delete(`${this._nomeControle}/${agendaId}/usuario/${usuarioId}`, this.GetHeader());
  }

  public atualizaPermissaoDoUsuarioNaAgenda(idUsuario: string, acessoPermissaoNaAgendaComLogInput: AcessoPermissaoNaAgendaComLogType) {
    return http.patch(
      `${this._nomeControle}/${idUsuario}`,
      acessoPermissaoNaAgendaComLogInput,
      this.GetHeader(),
    );
  }
}
